module.exports = __webpack_public_path__ + "img/wanjia_b.7103e18f.png";